import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBlock: 40,
    paddingInline: theme.palette.custom.lgPaddingInline,
    [theme.breakpoints.up('1700')]: {
      paddingInline: theme.palette.custom.xlPaddingInline,
    },
    [theme.breakpoints.down('md')]: {
      paddingInline: theme.palette.custom.smPaddingInline,
    },
  },
  breadcrumbs: {
    '& .MuiTypography-root': {
      [theme.breakpoints.down('sm')]: {
        fontSize: 13,
      },
    },
  },
  headerLabel: {
    '& .MuiTypography-root': {
      textAlign: 'center',
      paddingBlock: 12,
      color: '#333',
      fontWeight: 600,
      [theme.breakpoints.down('md')]: {
        fontSize: 30,
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 26,
      },
    },
  },
  btnWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    rowGap: 16,
    paddingBlock: 28,
  },
  btnContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    rowGap: 12,
    boxShadow: theme.palette.custom.boxShadow,
    marginInline: 12,
    paddingBlock: 24,
    '& .MuiTypography-root': {
      textAlign: 'center',
      [theme.breakpoints.down('md')]: {
        fontSize: 20,
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 18,
      },
    },
    [theme.breakpoints.down('md')]: {
      marginInline: 8,
      paddingInline: 8,
      minHeight: 180,
      justifyContent: 'center',
    },
  },
  addressWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    rowGap: 16,
    paddingBlock: 12,
    justifyContent: 'center',
  },
  addressCardWrapper: {
    paddingInline: 12,
  },
  addressCard: {
    border: '1px solid #e0e0e0',
    width: '100%',
    minHeight: 260,
    borderRadius: 20,
    paddingBlock: 20,
    paddingInline: 20,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#fbfafa',
    },
  },
  addressText: {
    '& .MuiTypography-root': {
      color: theme.palette.custom.main,
      textAlign: 'center',
      letterSpacing: 1,
      textTransform: 'uppercase',
    },
  },
  address: {
    paddingBlockStart: 12,
    '& .MuiTypography-root': {
      color: '#7a7a7a',
      textAlign: 'center',
    },
  },
  imgContainer: {
    width: '100%',
    height: 280,
    cursor: 'pointer',
    paddingInline: 12,
    [theme.breakpoints.up('1700')]: {
      height: 320,
    },
    [theme.breakpoints.down('md')]: {
      height: 340,
    },
  },
  img: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
}))

export default useStyles
